import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography, Slide } from '@material-ui/core';

import { BasicButton } from '../common/buttons';

const FLEX_SPACING = 2;

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

// Login page modal. Pre-defined styling for every element. Only contents are changing
const LoginAlert = ({ id, isOpen, cover, className, onClose }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      maxWidth="xs"
      open={isOpen}
      onClose={onClose}
      aria-labelledby={id}
      disableEscapeKeyDown
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      className={`home home--login-alert ${className}`}
    >
      <DialogTitle disableTypography id={id} style={{ backgroundImage: `url('${cover}')` }} />

      <DialogContent>
        <Grid container direction="column" alignItems="center" className="mb4">
          <Typography variant="h4" className="tc username">
            {formatMessage({
              id: 'login.successRenewPasswordAlert.caption1',
            })}
          </Typography>
          <Typography variant="h4" className="tc username">
            {formatMessage({
              id: 'login.successRenewPasswordAlert.caption2',
            })}
          </Typography>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Grid container spacing={FLEX_SPACING} justify="center">
          <Grid item xs={12} sm={6}>
            <BasicButton title={formatMessage({ id: 'buttonText.login' })} className="db modal-action" onClick={onClose} />
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

LoginAlert.defaultProps = { id: '', className: '' };

LoginAlert.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  cover: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LoginAlert;
